export default __webpack_public_path__ + "static/media/cx_cover_tln2s.46592db0.jpg";